const isSelectEvent = (e) => {
    if (e.type === 'click' || e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        return true;
    }
    return false;
};

export { isSelectEvent };
